import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { ISiteDetailsModel } from '@apps-common/types/portal/site-details'

export const updateSiteDetails = async (model: ISiteDetailsModel, image: any): Promise<ISiteDetailsModel> =>
  new Promise((resolve, reject) => {
    axios
      .post(`/my-monitoring/sites/UpdateSiteDetails`, model)
      .then((res) => {
        if (image) {
          const fileData = new FormData()

          fileData.append('file', image?.blob || image)
          axios
            .post(`/my-monitoring/sites/UploadSiteImg?unitId=${model.unitId}&siteId=${model.siteDetailsId}`, fileData)
            .then((imageRes) => resolve(imageRes?.data?.data))
            .catch((err) => reject(err))
        } else {
          resolve(res?.data?.data)
        }
      })
      .catch((err) => reject(err))
  })

type Props = {
  model: ISiteDetailsModel
  image: File | null | undefined
}

export const useMyMonitoringUpdateSiteDetails = (notify?: boolean, onSuccess?: (data: ISiteDetailsModel) => void) =>
  useMutation({
    mutationKey: ['updateMyMonitoringSiteDetails'],
    mutationFn: ({ model, image }: Props) => updateSiteDetails(model, image),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Updated site details.')
      }
    },
    onError: (error) => {
      if (notify) {
        toastError(error?.message || 'Failed to update site details, please try again.')
      }
    },
    throwOnError: false
  })
